// extracted by mini-css-extract-plugin
export default {"componentHolder":"SetScore_componentHolder__HH3tb","scoreInput":"SetScore_scoreInput__QVzaC"};